import { useState, useEffect } from 'react';
import { musikkAPI } from '@/services/api';
import type { Musikk } from '@/services/api';

interface UseTranspositionFormProps {
  musikk: Musikk | null;
  onSuccess: (message: string) => void;
  onError: (message: string) => void;
  onReload: () => void;
}

export const useTranspositionForm = ({
  musikk,
  onSuccess,
  onError,
  onReload,
}: UseTranspositionFormProps) => {
  const [transposeBy, setTransposeBy] = useState('0');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setTransposeBy('0');
  }, [musikk]);

  const handleSaveTransposition = async () => {
    if (!musikk?.id) return;
    
    try {
      setSaving(true);
      const transpose = parseInt(transposeBy);
      const notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
      const originalIndex = notes.indexOf(musikk?.grunntone || 'C');
      const newIndex = (originalIndex + transpose + 12) % 12;
      const newKey = notes[newIndex];
      const keyType = musikk?.toneart_type || 'dur';

      const data = {
        navn: `${newKey} ${keyType}`,
        grunntone: newKey,
        toneart_type: keyType,
        semitoner: transpose,
      };

      await musikkAPI.createTransponering(musikk.id, data);
      onSuccess('Transponering lagret');
      onReload();
    } catch (err: any) {
      console.error('Kunne ikke lagre transponering:', err);
      onError(err.response?.data?.error || 'Kunne ikke lagre transponering');
    } finally {
      setSaving(false);
    }
  };

  return {
    transposeBy,
    setTransposeBy,
    saving,
    handleSaveTransposition,
  };
};

